import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cancel-form"
}
const _hoisted_2 = { class: "popup__content" }
const _hoisted_3 = { class: "radio-list" }
const _hoisted_4 = { class: "radio" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { for: "NO_PAYMENT" }
const _hoisted_7 = {
  key: 0,
  class: "radio"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { for: "WAITING_CONFIRMATION" }
const _hoisted_10 = { class: "radio" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { for: "INVALID_REQUISITES" }
const _hoisted_13 = { class: "radio" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { for: "PAYOUT_BLACKLIST" }
const _hoisted_16 = { class: "radio" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { for: "UNABLE_TO_PAY_OUT_ON_REQ" }
const _hoisted_19 = {
  key: 1,
  class: "radio"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = { for: "PART_PAYOUT" }
const _hoisted_22 = {
  key: 0,
  class: "d-flex align-items-center gap-sm"
}
const _hoisted_23 = {
  for: "amount",
  class: "col-sm-4 col-form-label text-capitalize-first pe-2"
}
const _hoisted_24 = { class: "col-sm-4" }
const _hoisted_25 = {
  key: 1,
  class: "download-form"
}
const _hoisted_26 = {
  class: "download-form__text",
  id: "file-text"
}
const _hoisted_27 = { class: "col-sm-12" }
const _hoisted_28 = { class: "me-2" }
const _hoisted_29 = {
  key: 0,
  class: "spinner-border",
  role: "status",
  style: {"zoom":"0.5"}
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_32 = { class: "popup__controls" }
const _hoisted_33 = { class: "text-capitalize-first" }
const _hoisted_34 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "",
    title: _ctx.$t('labels.deal_action_confirmation', {action: _ctx.$t(`deals.action.refuse`)}),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      (_ctx.deal)
        ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.reason) = $event)),
                    value: _ctx.DisputeReason.NO_PAYMENT,
                    type: "radio",
                    name: "reason",
                    id: "NO_PAYMENT"
                  }, null, 8, _hoisted_5), [
                    [_vModelRadio, _ctx.form.reason]
                  ]),
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t(`dispute_reason.${_ctx.DisputeReason.NO_PAYMENT}_out`)), 1)
                ]),
                (_ctx.deal?.status !== _ctx.DealStatus.DISPUTE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.reason) = $event)),
                        value: _ctx.DisputeReason.WAITING_CONFIRMATION,
                        type: "radio",
                        name: "reason",
                        id: "WAITING_CONFIRMATION"
                      }, null, 8, _hoisted_8), [
                        [_vModelRadio, _ctx.form.reason]
                      ]),
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t(`dispute_reason.${_ctx.DisputeReason.WAITING_CONFIRMATION}`)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.reason) = $event)),
                    value: _ctx.DisputeReason.INVALID_REQUISITES,
                    type: "radio",
                    name: "reason",
                    id: "INVALID_REQUISITES"
                  }, null, 8, _hoisted_11), [
                    [_vModelRadio, _ctx.form.reason]
                  ]),
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t(`dispute_reason.${_ctx.DisputeReason.INVALID_REQUISITES}`)), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.reason) = $event)),
                    value: _ctx.DisputeReason.PAYOUT_BLACKLIST,
                    type: "radio",
                    name: "reason",
                    id: "PAYOUT_BLACKLIST"
                  }, null, 8, _hoisted_14), [
                    [_vModelRadio, _ctx.form.reason]
                  ]),
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t(`dispute_reason.${_ctx.DisputeReason.PAYOUT_BLACKLIST}`)), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.reason) = $event)),
                    value: _ctx.DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ,
                    type: "radio",
                    name: "reason",
                    id: "UNABLE_TO_PAY_OUT_ON_REQ"
                  }, null, 8, _hoisted_17), [
                    [_vModelRadio, _ctx.form.reason]
                  ]),
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t(`dispute_reason.${_ctx.DisputeReason.UNABLE_TO_PAY_OUT_ON_REQ}`)), 1)
                ]),
                (_ctx.deal?.status !== _ctx.DealStatus.DISPUTE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.reason) = $event)),
                        value: _ctx.DisputeReason.PART_PAYOUT,
                        type: "radio",
                        name: "reason",
                        id: "PART_PAYOUT"
                      }, null, 8, _hoisted_20), [
                        [_vModelRadio, _ctx.form.reason]
                      ]),
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t(`dispute_reason.${_ctx.DisputeReason.PART_PAYOUT}`)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            ([_ctx.DisputeReason.INVALID_SUM, _ctx.DisputeReason.PART_PAYOUT].includes(_ctx.form.reason))
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.helper.trans("labels.sum")), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`disputeReasonData.amount`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.amount) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          "data-maska": "9.##",
                          "data-maska-tokens": "9:[0-9]:multiple",
                          type: "text",
                          id: "amount"
                        }, null, 2), [
                          [_vModelText, _ctx.form.amount],
                          [_directive_maska]
                        ])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.DisputeReason.PART_PAYOUT === _ctx.form.reason)
              ? (_openBlock(), _createElementBlock("form", _hoisted_25, [
                  _createElementVNode("div", _mergeProps({
                    class: "download-form__container",
                    id: "drop-area"
                  }, _ctx.dropzone.getRootProps()), [
                    _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                    _cache[8] || (_cache[8] = _createElementVNode("svg", {
                      width: "48",
                      height: "48",
                      viewBox: "0 0 48 48",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M35.25 33H25.5V18.6216L30.4397 23.5603C30.7233 23.8297 31.1009 23.9777 31.4921 23.9727C31.8832 23.9677 32.2569 23.8101 32.5335 23.5335C32.8101 23.2569 32.9677 22.8832 32.9727 22.492C32.9777 22.1009 32.8297 21.7233 32.5603 21.4397L25.0603 13.9397C24.779 13.6586 24.3977 13.5007 24 13.5007C23.6023 13.5007 23.221 13.6586 22.9397 13.9397L15.4397 21.4397C15.1703 21.7233 15.0223 22.1009 15.0273 22.492C15.0323 22.8832 15.1899 23.2569 15.4665 23.5335C15.7431 23.8101 16.1168 23.9677 16.508 23.9727C16.8991 23.9777 17.2767 23.8297 17.5603 23.5603L22.5 18.6216V33H12.75C11.3581 32.9985 10.0236 32.4449 9.03933 31.4607C8.05509 30.4764 7.50149 29.1419 7.5 27.75V8.25C7.50149 6.85807 8.05509 5.52358 9.03933 4.53933C10.0236 3.55509 11.3581 3.00149 12.75 3H35.25C36.6419 3.00149 37.9764 3.55509 38.9607 4.53933C39.9449 5.52358 40.4985 6.85807 40.5 8.25V27.75C40.4985 29.1419 39.9449 30.4764 38.9607 31.4607C37.9764 32.4449 36.6419 32.9985 35.25 33ZM25.5 43.5C25.5 43.8978 25.342 44.2794 25.0607 44.5607C24.7794 44.842 24.3978 45 24 45C23.6022 45 23.2206 44.842 22.9393 44.5607C22.658 44.2794 22.5 43.8978 22.5 43.5V33H25.5V43.5Z",
                        fill: "#77818D"
                      })
                    ], -1)),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('labels.payout_upload_files')), 1)
                  ], 16),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileAttachments, (fileAttachment) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-2 ms-2",
                      key: fileAttachment.id
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_svg_icon, {
                          class: "icon icon__warning icon__small",
                          icon: "paperclip"
                        }),
                        _cache[10] || (_cache[10] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(fileAttachment.file.name), 1),
                        (fileAttachment.error === null && fileAttachment.attachment === null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[9] || (_cache[9] = [
                              _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                            ])))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.removeFile(fileAttachment)), ["prevent"])
                            }, [
                              _createVNode(_component_svg_icon, {
                                class: "icon icon__attention icon__small",
                                icon: "xmark"
                              })
                            ], 8, _hoisted_30)),
                        _createElementVNode("div", null, [
                          (fileAttachment.error !== null)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(fileAttachment.error), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
                class: "btn popup__close"
              }, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('button.cancel')), 1)
              ]),
              _createVNode(_component_LoaderButton, {
                "on-click": _ctx.refuse,
                class: "btn btn--reset"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('button.refuse')), 1)
                ]),
                _: 1
              }, 8, ["on-click"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}